export const LoginMapping = {
    loginRouter: '/login/:locationCode',
    signUpRouter: '/signup/:locationCode',
    forgotPasswordRouter: '/forgot-password/:locationCode'
};